import type { PokemonV2 } from '../../types/pokemon';
import type { otherSetting } from '../../types/other-setting';
import { OFFENCE_ITEM_ID_KODAWARISUKAFU } from '../../types/item';
import { calcRankedValue } from '../damage/core-utils';
import { isSlowStartActive } from '../ability';
import { hasPokemonStatus } from '../pokemon/status';

export type PowerMoveSpeedModifiers = {
  tailwind?: boolean;
  paralysis?: boolean;
};

// 可変威力技（ジャイロボール/エレキボール）向けの判定用Sを算出する
export const calcEffectiveSpeedForPowerMoves = (
  pokemon: PokemonV2,
  otherSetting: otherSetting,
  modifiers?: PowerMoveSpeedModifiers,
): number => {
  // 将来の場補正対応に備えて引数を保持する
  void otherSetting;

  const baseSpeed = pokemon.effective_value?.speed ?? 0;
  const rank = pokemon.rankCorrection?.speed ?? 0;
  let result = baseSpeed;

  if (rank !== 0) {
    result = calcRankedValue(result, rank);
  }

  if (pokemon.selected_item_id === OFFENCE_ITEM_ID_KODAWARISUKAFU) {
    result = Math.floor(result * 1.5);
  }

  if (modifiers?.tailwind) {
    result = Math.floor(result * 2);
  }

  const isParalyzed =
    hasPokemonStatus(pokemon.other_setting, 'paralyzed') || Boolean(modifiers?.paralysis);
  if (isParalyzed) {
    result = Math.floor(result * 0.5);
  }

  // 第5世代以降の仕様に合わせ、まひ補正の後にスロースタートを適用する
  if (isSlowStartActive(pokemon)) {
    result = Math.floor(result * 0.5);
  }

  return result;
};
